export const CONTENT_ITEM_HEIGHT = 60;
export const CONTENT_MENU_HORIZONTAL_SHIFT = 113;
export const CONTENT_MENU_VERTICAL_SHIFT = 25;
